import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('subject-table', _vm._g(_vm._b({
    attrs: {
      "columns": _vm.columns,
      "data": _vm.data
    }
  }, 'subject-table', _vm.$attrs, false), _vm.$listeners), [_c('a-alert', {
    staticClass: "mb-20",
    attrs: {
      "slot": "tip",
      "message": _vm.t('请依次完成主体信息认证/提交审核'),
      "type": "info",
      "show-icon": ""
    },
    slot: "tip"
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };